import { makeStyles, Theme } from '@material-ui/core/styles';

const useStylesGrid = makeStyles((theme: Theme) => ({
    root: {
        marginBottom: theme.spacing(3),
    },

    gridColumnHeaderSubGrid: {
        padding: `${theme.spacing(0, 1.5)} !important`,
        borderRight: '1px solid #fff !important',
        backgroundColor: '#0d273e',
        color: '#fff',

        '&.k-sorted': {
            borderRight: '1px solid #fff !important',
            backgroundColor: '#0d273e',
            color: theme.palette.grey[400],

            '& .k-icon': {
                color: theme.palette.grey[400],
            },
        },
        '&:hover': {
            color: theme.palette.grey[400],
        },
        '& .k-link': {
            fontWeight: 'normal',
            '&:hover': {
                color: theme.palette.grey[400],
            },
        },
    },
    gridColumnHeader: {
        padding: `${theme.spacing(0.5, 1.5)} !important`,
        borderRight: '1px solid #fff !important',
        backgroundColor: '#0d273e',
        color: '#fff',

        '&.k-sorted': {
            borderRight: '1px solid #fff !important',
            backgroundColor: '#0d273e',
            color: theme.palette.grey[400],

            '& .k-icon': {
                color: 'black',
            },
        },
        '&:hover': {
            color: theme.palette.grey[400],
        },
        '& .k-link': {
            fontWeight: 'normal',
            '&:hover': {
                color: theme.palette.grey[400],
            },
        },
        '& [type="checkbox"]': {
            borderColor: 'white',
        },
    },
    gridColumn: {
        padding: `${theme.spacing(0.5, 1.5)} !important`,
        borderRightWidth: '1px !important',
        fontSize: '12px',
        width: '100%',
        '&:last-child': {
            borderRightWidth: '0px !important',
            textOverflow: 'clip',
        },
    },
    gridColumnObsolete: {
        padding: `${theme.spacing(0.5, 1.5)} !important`,
        borderRightWidth: '1px !important',
        fontSize: '12px',
        background: '#c0c0c0',
        width: '100%',
        '&:last-child': {
            borderRightWidth: '0px !important',
            textOverflow: 'clip',
        },
    },
    gridVtsNesOneCde: {
        '& .k-grid-container': {
            maxHeight: '90vh!important',
        },
    },
    gridPreparation: {
        '& .k-grid-container': {
            maxHeight: '42vh!important',
        },
    },
    gridDocumentFindingComments: {
        '& .k-grid-container': {
            maxHeight: '60vh !important',
        },
    },
    grid: {
        width: '100%',
        '& .k-grid-container': {
            maxHeight: '66vh',
        },

        '& .k-grid-toolbar': {
            backgroundColor: theme.palette.primary.main,
            borderBottom: `1px solid ${theme.palette.grey[400]} !important`,
            padding: `${theme.spacing(0.5, 1.5)} !important`,
            minHeight: '40px',
        },
        '& .k-grid-header': {
            backgroundColor: '#0d273e',
            borderBottom: `1px solid ${theme.palette.grey[400]} !important`,
        },
        '& .k-master-row': {
            '&:nth-of-type(even)': {
                backgroundColor: theme.palette.action.hover,
            },

            '&:hover': {
                backgroundColor: 'rgb(13, 39, 62, 0.25)',
            },

            '&.k-state-selected': {
                backgroundColor: '#8dd9c8',
            },

            '& td:first-child': {
                fontWeight: 'bold',
            },
        },
    },
    wrapperNewDocument: {
        '& .k-grid-toolbar': {
            minHeight: '50px!important',
        },
    },
    gridTestersTable: {
        '& tr td:first-child': {
            fontWeight: 'unset !important',
        },
    },
    gridSearch: {
        '& .k-grid-container': {
            maxHeight: '60vh',
        },
    },
    maxHeight100p: {
        maxHeight: '100%',
    },
    subGridDocuents: {
        maxHeight: '40vh',
        overflowX: 'auto',
    },
    gridTemplateCell: {
        '& .k-grid-container': {
            maxHeight: '68vh',
        },
        '& .k-alt': {
            backgroundColor: '#fff !important',
        },
        '& .k-grid-toolbar': {
            backgroundColor: '#f5f5f5',
            borderBottom: `1px solid ${theme.palette.grey[400]} !important`,
            padding: `${theme.spacing(0.5, 1.5)} !important`,
        },
        '& .k-grid-header': {
            backgroundColor: '#0d273e',
            borderBottom: `1px solid ${theme.palette.grey[400]} !important`,
        },
        '& .k-master-row': {
            '&:nth-of-type(even)': {
                backgroundColor: theme.palette.action.hover,
            },

            '&:hover': {
                backgroundColor: 'transparent',
            },

            '&.k-state-selected': {
                backgroundColor: '#8dd9c8',
            },

            '& td:first-child': {
                fontWeight: 'bold',
            },
        },
    },
    actionButton: {
        minWidth: 24,
        padding: '2px 5px',
        textTransform: 'none',
    },
    actionButtonIcon: {
        fontSize: 16,
    },
    textCenter: {
        textAlign: `center`,
        justifyContent: 'center',
    },
    maxHeight70VH: {
        '& .k-grid-container': {
            maxHeight: '53vh',
        },
    },
    fileNameDocumentGridViewDocuments: {
        borderRightWidth: '1px !important',
        fontSize: 12,
    },
    gridColumnHeaderCursorDefault: {
        '& .k-link': {
            cursor: 'default !important',
        },
        '& .k-link:hover': {
            color: '#fff',
        },
    },
    headerGrid: {
        '& .k-grid-container': {
            maxHeight: '30vh',
        },
    },
    defaultCursor: {
        '& .k-link': {
            cursor: 'default !important',
        },
        cursor: 'default !important',
    },
    pointerCursor: {
        '&:last-child .k-link': {
            cursor: 'default !important',
        },
    },
    reorganizeGridHeight: {
        '& .k-grid-container': {
            maxHeight: '15vh',
        },
    },
    noPadding: {
        padding: '0 !important',
    },
    columnFiltered: {
        '& .k-icon.k-i-more-vertical': {
            color: 'red',
        },
    },
    wrapText: {
        overflowWrap: 'anywhere',
    },
    headerUnclickable: {
        pointerEvents: 'none',
    },
}));

export default useStylesGrid;
